function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M126.25,16A1.75,1.75,0,0,0,128,14.25V1.751A1.75,1.75,0,0,0,126.25,0H1.75A1.751,1.751,0,0,0,0,1.751v12.5A1.751,1.751,0,0,0,1.75,16H8.583v96H1.75A1.751,1.751,0,0,0,0,113.752v12.5A1.751,1.751,0,0,0,1.75,128h124.5a1.75,1.75,0,0,0,1.75-1.75v-12.5a1.75,1.75,0,0,0-1.75-1.75h-6.833V16ZM3.5,3.5h121v9H3.5Zm121,121H3.5v-9h121ZM115.917,112H12.083V16H115.917Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.583,103.752a1.751,1.751,0,0,0,1.75,1.75h87.334a1.75,1.75,0,0,0,1.75-1.75V24.25a1.75,1.75,0,0,0-1.75-1.75H20.333a1.751,1.751,0,0,0-1.75,1.75v79.5Zm3.5-34H58.25V102H22.083ZM69.75,102V69.751h36.167V102Zm36.167-43.751H69.75V26h36.167ZM66.25,26V60A1.75,1.75,0,0,0,68,61.751h37.917v4.5H68A1.75,1.75,0,0,0,66.25,68v34h-4.5V68A1.751,1.751,0,0,0,60,66.251H22.083v-4.5H60A1.751,1.751,0,0,0,61.75,60V26Zm-8,0V58.251H22.083V26Z"
}));

function SvgWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.d6269fae.svg";
export { ForwardRef as ReactComponent };